import { create } from 'zustand';
import {
  infermedicaSurveySlice,
  TInfermedicaSurveySlice,
} from './infermedicaSurvey.slice';
import { isabelSurveySlice } from './isabelSurvey.slice';
import { manualIntakeSlice } from './manualIntake.slice';
import type { IIsabelSurveySlice, IManualIntakeSlice } from './types';

export type TSurveyStore = TInfermedicaSurveySlice &
  IIsabelSurveySlice &
  IManualIntakeSlice;

export const useSurveyStore = create<TSurveyStore>()((...arg) => ({
  ...infermedicaSurveySlice(...arg),
  ...isabelSurveySlice(...arg),
  ...manualIntakeSlice(...arg),
}));
